










































import path from "path";
import { Component, Vue, Watch } from "vue-property-decorator";
import VueRouter, { Route, RouteRecord, RouteConfig } from "vue-router";
import { PermissionModule } from "@/store/modules/permission";
import { TagsViewModule, ITagView } from "@/store/modules/tags-view";
import ScrollPane from "./ScrollPane.vue";

@Component({
  name: "TagsView",
  components: {
    ScrollPane,
  },
})
export default class extends Vue {
  private visible: boolean = false;
  private top: number = 0;
  private left: number = 0;
  private selectedTag: any = {};
  private affixTags: ITagView[] = [];

  get visitedViews() {
    return TagsViewModule.visitedViews;
  }

  get routes() {
    return PermissionModule.routes;
  }

  @Watch("$route")
  private onRouteChange() {
    this.addTags();
    this.moveToCurrentTag();
  }

  @Watch("visible")
  private onVisibleChange(value: boolean) {
    if (value) {
      document.body.addEventListener("click", this.closeMenu);
    } else {
      document.body.removeEventListener("click", this.closeMenu);
    }
  }

  mounted() {
    this.initTags();
    this.addTags();
  }

  private isActive(route: ITagView) {
    return route.path === this.$route.path;
  }

  private isAffix(tag: ITagView) {
    return tag.meta && tag.meta.affix;
  }

  private filterAffixTags(routes: RouteConfig[], basePath = "/") {
    let tags: ITagView[] = [];
    routes.forEach((route) => {
      if (route.meta && route.meta.affix) {
        const tagPath = path.resolve(basePath, route.path);
        tags.push({
          fullPath: tagPath,
          path: tagPath,
          name: route.name,
          meta: { ...route.meta },
        });
      }
      if (route.children) {
        const childTags = this.filterAffixTags(route.children, route.path);
        if (childTags.length >= 1) {
          tags = [...tags, ...childTags];
        }
      }
    });
    return tags;
  }

  private initTags() {
    this.affixTags = this.filterAffixTags(this.routes);
    for (const tag of this.affixTags) {
      // Must have tag name
      if (tag.name) {
        TagsViewModule.addVisitedView(tag);
      }
    }
  }

  private addTags() {
    const { name } = this.$route;
    if (name) {
      TagsViewModule.addView(this.$route);
    }
    return false;
  }

  private moveToCurrentTag() {
    const tags = this.$refs.tag as any[];
    this.$nextTick(() => {
      for (const tag of tags) {
        if ((tag.to as ITagView).path === this.$route.path) {
          (this.$refs.scrollPane as ScrollPane).moveToTarget(tag as any);
          if ((tag.to as ITagView).fullPath !== this.$route.fullPath) {
            TagsViewModule.updateVisitedView(this.$route);
          }
          break;
        }
      }
    });
  }

  private refreshSelectedTag(view: ITagView) {
    TagsViewModule.delCachedView(view);
    const { fullPath } = view;
    this.$nextTick(() => {
      this.$router.replace({
        path: "/redirect" + fullPath,
      });
    });
  }

  private closeSelectedTag(view: ITagView) {
    TagsViewModule.delView(view);
    if (this.isActive(view)) {
      this.toLastView(TagsViewModule.visitedViews, view);
    }
  }

  private closeOthersTags() {
    this.$router.push(this.selectedTag);
    TagsViewModule.delOthersViews(this.selectedTag);
    this.moveToCurrentTag();
  }

  private closeAllTags(view: ITagView) {
    TagsViewModule.delAllViews();
    if (this.affixTags.some((tag) => tag.path === this.$route.path)) {
      return;
    }
    this.toLastView(TagsViewModule.visitedViews, view);
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView: any = visitedViews.slice(-1)[0];
    if (latestView) {
      this.$router.push(latestView);
    } else {
      if (view.name === "Dashboard") {
        this.$router.replace({ path: "/redirect" + view.fullPath });
      } else {
        this.$router.push("/");
      }
    }
  }

  private openMenu(tag: ITagView, e: MouseEvent) {
    const menuMinWidth = 105;
    const offsetLeft = this.$el.getBoundingClientRect().left;
    const offsetWidth = (this.$el as HTMLElement).offsetWidth;
    const maxLeft = offsetWidth - menuMinWidth;
    const left = e.clientX - offsetLeft + 15;
    if (left > maxLeft) {
      this.left = maxLeft;
    } else {
      this.left = left;
    }
    this.top = e.clientY;
    this.visible = true;
    this.selectedTag = tag;
  }

  private closeMenu() {
    this.visible = false;
  }
}
